import { render, staticRenderFns } from "./CatalogSubscription.vue?vue&type=template&id=02b24c96"
import script from "./CatalogSubscription.vue?vue&type=script&lang=ts"
export * from "./CatalogSubscription.vue?vue&type=script&lang=ts"
import style0 from "./CatalogSubscription.vue?vue&type=style&index=0&id=02b24c96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports